import { useTranslation } from 'react-i18next';

import { ICreationConfig } from '@/features/user/store/createUser.types';
import { CreateUserStepsContents } from '@/features/user/components/CreateUser/StepNavigation/CreateUserStepsContents';
import { TUserCreationType } from '@/store/models/dashboard-config.model';

export const useStepNavigationConfig = ({ userType }: { userType: TUserCreationType }) => {
  const { t } = useTranslation();

  if (!userType) return {};

  const userCreationSteps: Record<TUserCreationType, ICreationConfig<string>> = {
    physical: {
      title: t('pages.dashboard.createUser.physical'),
      steps: [
        'CreateUserPhysicalUserInformation',
        'CreateUserPhysicalVerificationDetails',
        'CreateUserPhysicalSummary',
      ],
    },
    business: {
      title: t('pages.dashboard.createUser.business.title'),
      steps: [
        'CreateUserBusinessInformation',
        'CreateUserBusinessVerificationDetails',
        'CreateUserCompanyMembers',
        'CreateUserBusinessSummary',
      ],
    },
    selfEmployed: {
      title: t('pages.dashboard.createUser.selfEmployed.title'),
      steps: ['CreateUserSelfUserInformation', 'CreateUserSelfVerificationDetails', 'CreateUserSelfSummary'],
    },
    parent: {},
    governmental: {},
    nonGovernmental: {},
  };

  const stepcontents = CreateUserStepsContents({ steps: userCreationSteps });

  const { title, steps } = stepcontents[userType];

  return { userCreationSteps, stepTitle: title, steps };
};
